/**
 * src/utils/categoryIcons.tsx
 * Dynamic Category Icon and Color Mappings for CKAudit v2
 */

import React from 'react';
import {
  Utensils,
  Coffee,
  Smartphone,
  Banknote,
  Home,
  Car,
  ShoppingBag,
  Tag,
  Fuel,
  HeartPulse,
  Film,
  Gift,
  Wrench,
  Shield,
  Sparkles,
  Plane,
  Music,
  Bookmark,
  Briefcase,
  Zap,
  CreditCard,
  Package
} from 'lucide-react';

export interface IconOption {
  name: string;
  label: string;
  icon: React.FC<{ size?: number; className?: string; color?: string; strokeWidth?: number }>;
}

export const CATEGORY_ICONS: IconOption[] = [
  { name: 'Utensils', label: 'Food & Dining', icon: Utensils },
  { name: 'Coffee', label: 'Tea & Snacks', icon: Coffee },
  { name: 'Smartphone', label: 'Digital / UPI', icon: Smartphone },
  { name: 'Banknote', label: 'Cash & Bills', icon: Banknote },
  { name: 'Home', label: 'Rent & Space', icon: Home },
  { name: 'Car', label: 'Travel & Commute', icon: Car },
  { name: 'Fuel', label: 'Fuel & Petrol', icon: Fuel },
  { name: 'ShoppingBag', label: 'Groceries / Market', icon: ShoppingBag },
  { name: 'Tag', label: 'General / Miscellaneous', icon: Tag },
  { name: 'CreditCard', label: 'Card Payment', icon: CreditCard },
  { name: 'Briefcase', label: 'Office & Business', icon: Briefcase },
  { name: 'Wrench', label: 'Maintenance / Hardware', icon: Wrench },
  { name: 'Package', label: 'Supplies / Delivery', icon: Package },
  { name: 'HeartPulse', label: 'Health & Medical', icon: HeartPulse },
  { name: 'Gift', label: 'Celebration & Gifts', icon: Gift },
  { name: 'Film', label: 'Entertainment / Movies', icon: Film },
  { name: 'Plane', label: 'Trips / Flights', icon: Plane },
  { name: 'Music', label: 'Events / Leisure', icon: Music },
  { name: 'Sparkles', label: 'Special / Bonus', icon: Sparkles },
  { name: 'Shield', label: 'Security & Legal', icon: Shield },
  { name: 'Zap', label: 'Electricity & Utilities', icon: Zap },
  { name: 'Bookmark', label: 'Education / Books', icon: Bookmark },
];

export const APPLE_COLORS = [
  { label: 'Blue', hex: '#0a84ff' },
  { label: 'Green', hex: '#30d158' },
  { label: 'Orange', hex: '#ff9f0a' },
  { label: 'Red', hex: '#ff453a' },
  { label: 'Purple', hex: '#bf5af2' },
  { label: 'Indigo', hex: '#5e5ce6' },
  { label: 'Cyan', hex: '#64d2ff' },
  { label: 'Yellow', hex: '#ffd60a' },
  { label: 'Pink', hex: '#ff375f' },
  { label: 'Slate', hex: '#8e8e93' },
];

export function renderCategoryIcon(iconName?: string | null, size: number = 18, color?: string) {
  const match = CATEGORY_ICONS.find(item => item.name.toLowerCase() === (iconName || '').toLowerCase());
  const IconComponent = match ? match.icon : Tag;
  return <IconComponent size={size} color={color} strokeWidth={2.2} />;
}
